import Env from '../base/env.js'
import Channels from '../base/channels.js'
import gsap from 'gsap'
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

class MainnavTouch
{
    constructor()
    {


        if(Env.$mainNav == null) {
            return false
        }
        this.DOM = {}
        this.DOM.view = Env.$mainNav
        this.DOM.menu = this.DOM.view.querySelector('.jsMenu')
        this.DOM.close = this.DOM.view.querySelector('.jsClose')
        this.DOM.closeLines = this.DOM.close.querySelectorAll('.jsLine')
        this.DOM.closeText = this.DOM.close.querySelector('.text')
        this.DOM.triggers = Env.$body.querySelectorAll('.jsMainnav--trigger')
        this.DOM.triggersDS = Env.$body.querySelectorAll('.jsTrigger--DS')
        this.DOM.fill = this.DOM.view.querySelector('.jsFill-bg')
        this.DOM.fillSlideshow = this.DOM.view.querySelector('.jsFill-slideshow')
        this.DOM.primary = this.DOM.view.querySelector('.jsMainnav')
        this.DOM.primaryItems = this.DOM.view.querySelectorAll('.jsEntryFx')
        this.DOM.textsInItems = this.DOM.view.querySelectorAll('.jsTextIn')
        this.DOM.secondary = this.DOM.view.querySelector('.jsSecondaryFx')
        this.DOM.secondaryItems = this.DOM.secondary.querySelectorAll('li')
        this.DOM.slideshow = this.DOM.view.querySelector('.jsSlideshow')
        this.DOM.collection = this.DOM.view.querySelector('.jsCollection')
        this.DOM.slides = this.DOM.view.querySelectorAll('.jsSlide')
        //
        this.FX_VARS = {
          primaryItems:{
            from:{
              y:65,
              color:'#fff'
            },
            to:{
              color:'#717171'
            }
          },
          textIn:{
            from:{
              y:0
            },
            to:{
              y:52
            }
          },
          textOut:{
            from:{
              y:-52
            },
            to:{
              y:0
            }
          }
        }
        // Flags
        this.IS_ANIMATING = false
        this.CURRENT_SLIDE = 0
        this.Z_INDEX = 1
        this.IS_TRANSITIONING = false
        // Fns
        this.events()
        this.resize()
        this.mount()
    }

    mount()
    {
      gsap.set(this.DOM.close, { autoAlpha:1 })
      gsap.set(this.DOM.closeLines, { autoAlpha:0 })
      gsap.set(this.DOM.secondary, { autoAlpha:1 })
      gsap.set(this.DOM.secondaryItems, { autoAlpha:0 })
      gsap.set(this.DOM.primaryItems, { autoAlpha:1, y:this.FX_VARS.primaryItems.from.y })
      gsap.set(this.DOM.slides, { autoAlpha:1, zIndex:0 })

      this.setupTexts()
      this.showSlide(this.CURRENT_SLIDE,false)

    }

    calculateMask(direction)
    {
      const viewport = Env.framework.toolbox.getViewport()
      let value;
      if(direction == 'from') {
        value = `rect(0px,0px,${viewport.height}px,0)`;
      } else if(direction == 'to') {
        value = `rect(0px,${viewport.width / 2 }px,${viewport.height}px,0)`;
      }
      return value;
    }


    close(funcStart=null,funcComplete=null)
    {
        this.out(
            ()=>{
                Channels.emit('mainnav::closing')
                this.IS_ANIMATING = true
                this.DOM.view.classList.remove('is--active');
                Env.$html.classList.remove('mainnav--isOpened')
                Env.$html.classList.add('mainnav--isLeaving')
                Env.$html.classList.remove('mainnav--isFinalize')
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            ()=>{
                this.IS_ANIMATING = false
                Env.$html.classList.remove('mainnav--isLeaving')
                Env.$html.classList.remove('mainnav--isFinalize')
                if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        )
    }

    events()
    {
        var
        self = this

        for ( const e of this.DOM.triggers ) {
            e.addEventListener('click',()=>{
                if(this.IS_ANIMATING == false)
                {
                    this.toggle()
                }
                return false;
            },false)
        }

        Channels.on('mainnav::close',()=>
        {
            this.close()
        })

        Channels.on('statechange::before',()=>
        {
            this.IS_TRANSITIONING = true
        })

        Channels.on('statechange::finalize',()=>
        {
          this.IS_TRANSITIONING = false
        })

        Channels.on('window::smartresize',()=>{
            if(Env.mobileCSS === false)
            {
                this.resize()
                if(this.DOM.view != null) {
                    this.DOM.view.removeAttribute('style')
                }
            }
        })

        this.hoverFX()
    }

    getStatus()
    {
        return this.DOM.view.classList.contains('is--active')
    }

    hoverFX()
    {
      this.DOM.menu.addEventListener('mouseenter',()=>{
        gsap.to(
          this.DOM.primaryItems,
          {
            color:this.FX_VARS.primaryItems.to.color,
            duration:.5,
            ease:'cubic.out'
          }
        )
      })
      this.DOM.menu.addEventListener('mouseleave',()=>{
        gsap.to(
          this.DOM.primaryItems,
          {
            color:this.FX_VARS.primaryItems.from.color,
            duration:.5,
            ease:'cubic.out'
          }
        )
      })

      for (const [i, item] of this.DOM.primaryItems.entries()) {

        item.addEventListener('mouseenter',()=>{
          const getTextIn = this.FX.textsInItems[i]
          const getTextOut = this.FX.textsOutItems[i]
          const DOM = {}
          DOM.textOut = item.querySelector('.jsTextOut')
          this.tlHover = gsap.timeline()
          this.tlHover.add([
            gsap.to(
              DOM.textOut,
              {
                color:this.FX_VARS.primaryItems.from.color,
                duration:.5,
                ease:'cubic.out'
              }
            ),
            gsap.fromTo(
              getTextIn.chars,
              {
                y:this.FX_VARS.textIn.from.y
              },
              {
                y:this.FX_VARS.textIn.to.y,
                duration:.6,
                ease:'power3.inOut',
                stagger:.03
              }
            ),
            gsap.fromTo(
              getTextOut.chars,
              {
                y:this.FX_VARS.textOut.from.y
              },
              {
                y:this.FX_VARS.textOut.to.y,
                duration:.6,
                ease:'quint.inOut',
                stagger:.03
              }
            )
          ])
          this.showSlide(i)
        })
        item.addEventListener('mouseleave',()=>{
          if(this.IS_TRANSITIONING == false) {
            this.tlHover.reverse()
          }
        })
      }
    }


    in(funcStart='',funcComplete='')
    {

        let tl = gsap.timeline({
            onStart:()=>{
                this.status = 'animating'
                if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
              this.status = 'in'
              Env.$html.classList.add('mainnav--isFinalize')
              if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        const getValueClipFrom = this.calculateMask('from')
        const getValueClipTo = this.calculateMask('to')

        tl.add([
          gsap.fromTo(
            this.DOM.fill,
            {
              autoAlpha:1,
              x:'-100%'
            },
            {
              x:0,
              ease:'expo.inOut',
              duration:1.2
            }
          ),
          gsap.fromTo(
            this.DOM.slideshow,
            {
              clip:getValueClipFrom
            },
            {
              clip:getValueClipTo,
              ease:'expo.inOut',
              duration:1.2
            }
          ),
          gsap.fromTo(
            this.DOM.collection,
            {
              scale:1.1
            },
            {
              scale:1,
              ease:'quint.out',
              duration:1,
              delay:.5
            }
          ),
          gsap.fromTo(
            this.DOM.fillSlideshow,
            {
              autoAlpha:1
            },
            {
              autoAlpha:0,
              ease:'cubic.out',
              duration:1.2,
              delay:.5
            }
          )
        ])
        tl.add([
          gsap.fromTo(
            this.DOM.primaryItems,
            {
              autoAlpha:1
            },
            {
              y:0,
              ease:'quint.out',
              duration:1,
              stagger:.05
            }
          ),
          gsap.to(
            this.DOM.secondaryItems,
            {
              autoAlpha:1,
              duration:1,
              ease:'cubic.out',
              stagger:.05,
              delay:.25
            }
          ),
          gsap.fromTo(
            this.DOM.closeLines[0],
            {
              autoAlpha:1,
              x:-17
            },
            {
              x:0,
              duration:1,
              ease:'quint.inOut',
            }
          ),
          gsap.fromTo(
            this.DOM.closeLines[1],
            {
              autoAlpha:1,
              x:17
            },
            {
              x:0,
              duration:1,
              ease:'quint.inOut',
              delay:.25
            }
          ),
          gsap.fromTo(
            this.DOM.closeText,
            {
              autoAlpha:0,
            },
            {
              autoAlpha:1,
              duration:1,
              ease:'cubic.inOut',
              delay:.25
            }
          )
        ],'-=1.2')
        if(Env.mobileCSS) {
          tl.add([
            gsap.fromTo(
              this.DOM.triggersDS,
              {
                autoAlpha:0
              },
              {
                autoAlpha:1,
                duration:1,
                ease:'cubic.out'
              }
            )
          ],'<')
        }
    }

    out(funcStart='',funcComplete='')
    {

        let tl = gsap.timeline({
            onStart:()=>{
              this.status = 'animating'

              Env.$html.classList.add('mainnav--isLeaving')

              for (const item of this.FX.textsInItems) {
                gsap.set(item.chars,{ clearProps:'y' })
              }
              setTimeout(() => {
                this.resetTextOut()
              }, 100);

              gsap.set(this.DOM.textOutItems, { clearProps:'color' })
              if(typeof funcStart == 'function' || funcStart != null) funcStart()
            },
            onComplete:()=>{
              this.status = 'out'
              setTimeout(() => {
                this.resetTextOut()
              }, 100);
              if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
            }
        })

        const getValueClip = this.calculateMask('from')

        // for (const item of this.FX.textsInItems) {
        //   gsap.to(item.chars,{ y:this.FX_VARS.textIn.from.y,duration:.2 })
        // }
        // for (const item of this.FX.textsOutItems) {
        //   gsap.to(item.chars,{ y:this.FX_VARS.textOut.from.y,duration:.2 })
        // }
        tl.add([
          gsap.to(
            this.DOM.closeLines[0],
            {
              x:-17,
              duration:1,
              ease:'quint.inOut',
            }
          ),
          gsap.to(
            this.DOM.closeLines[1],
            {
              x:17,
              duration:1,
              ease:'quint.inOut',
              delay:.25
            }
          ),
          gsap.to(
            this.DOM.closeText,
            {
              autoAlpha:0,
              duration:1,
              ease:'cubic.inOut',
              delay:.25
            }
          ),
          gsap.to(
            this.DOM.secondaryItems,
            {
              autoAlpha:0,
              duration:1,
              ease:'cubic.out',
            }
          ),
          gsap.to(
            this.DOM.primaryItems,
            {
              y:this.FX_VARS.primaryItems.from.y,
              ease:'quint.out',
              duration:1,
              stagger:.035
            }
          ),
        ])
        if(Env.mobileCSS) {
          tl.add([
            gsap.to(
              this.DOM.triggersDS,
              {
                autoAlpha:0,
                duration:1,
                ease:'cubic.out'
              }
            )
          ],'<')
        }
        tl.add([
          gsap.to(
            this.DOM.slideshow,
            {
              clip:getValueClip,
              ease:'expo.inOut',
              duration:1.2
            }
          ),
          gsap.to(
            this.DOM.fillSlideshow,
            {
              autoAlpha:1,
              ease:'cubic.out',
              duration:1.2
            }
          ),
          gsap.to(
            this.DOM.fill,
            {
              x:'-100%',
              ease:'expo.inOut',
              duration:1.2
            }
          ),
        ],'-=1.2')

    }



    resize()
    {

      const viewport = Env.framework.toolbox.getViewport()
      const getClipFrom = this.calculateMask('from')
      gsap.set(this.DOM.slideshow, { autoAlpha:1, clip:getClipFrom })

    }

    setupTexts()
    {
      this.FX = {}
      this.FX.textsInItems = []
      this.FX.textsOutItems = []
      this.DOM.textOutItems = []
      for(let item of this.DOM.textsInItems) {

        let DOM = {}
        const getText = item.innerHTML
        DOM.textOut = document.createElement('span')
        DOM.textOut.classList.add('jsTextOut')
        DOM.textOut.classList.add('tw-absolute')
        DOM.textOut.classList.add('tw-left-0')
        DOM.textOut.classList.add('tw-top-0')
        DOM.textOut.innerHTML = getText
        item.parentElement.appendChild(DOM.textOut)
        this.FX.textsOutItems.push(new SplitText(DOM.textOut, { type:'chars' }))
        this.FX.textsInItems.push(new SplitText(item, { type:'chars' }))
        this.DOM.textOutItems.push(DOM.textOut)

      }
    }

    showSlide(i,animate=true)
    {
      if(animate == true) {
        if(i != this.CURRENT_SLIDE) {
          const DOM = {}
          DOM.new = this.DOM.slides[i]
          gsap.fromTo(
            DOM.new,
            {
              autoAlpha:0,
              scale:1.1,
              zIndex:this.Z_INDEX
            },
            {
              scale:1,
              autoAlpha:1,
              ease:'power3.inOut',
              duration:1.5,
              onStart:()=>{
                this.CURRENT_SLIDE = i
              }
            }
          )
          this.Z_INDEX++
        }
      } else {
        gsap.set(this.DOM.slides[i], { autoAlpha: 1,zIndex:1 })
      }
    }

    toggle(_status)
    {
        if (typeof _status === 'undefined')
            _status = this.DOM.view.classList.contains('is--active')

        if(!!_status)
        {
            this.close()
        }
        else
        {
            this.in(
                ()=>{
                    this.IS_ANIMATING = true
                    this.DOM.view.classList.add('is--active');
                    Env.$html.classList.add('mainnav--isOpened')
                },
                ()=>{

                    this.IS_ANIMATING = false
                }
            )
        }
    };

    resetTextOut()
    {
      for (const item of this.FX.textsOutItems) {
        gsap.killTweensOf(item.chars)
        gsap.set(item.chars,{ clearProps:'y' })
      }
    }
}

export default MainnavTouch;
